import { utcToZonedTime } from 'date-fns-tz';
import { format } from 'date-fns';

export const convertToBelgianDate = (input: string, formatType: string) => {
  const zonedDate = utcToZonedTime(input, 'Europe/Brussels');
  const output = format(zonedDate, formatType);

  return output;
};
